<!-- 定向询价 enquiryType: 0 Enquiry/querySupplierOfferList-->
<template>
  <div>
    <Comment :query="{ enquiryType: 0 }" back="/directedInquiry" />
  </div>
</template>

<script>
import Comment from './components/common.vue';
export default {
  name: 'DirectedInquiry',
  components: { Comment },
};
</script>
<style lang="scss" scoped></style>
